import { Icon } from '@types';

export const Done = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 48 48"
			height="48"
			width="48"
		>
			<path d="M18.9 35.7 7.7 24.5 9.85 22.35 18.9 31.4 38.1 12.2 40.25 14.35Z" />
		</svg>
	);
};
